const state = {
  show: false,
  messageData: undefined,
};

const mutations = {
  setShow(state, isShow) {
    state.show = isShow;
  },

  setMessageData(state, data) {
    state.messageData = data;
  },
};

const actions = {};

const getters = {
  show(state) {
    return state.show;
  },

  messageData(state) {
    return state.messageData;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
